/*
 *******************************************************************************
 * 
 *  Filename:   ./constants/actionTypeLocationZipCodes.js
 *
 *  Syntax:     NA
 *
 *  Synopsis:   Location Zip Code Type Action Type constant definitions.
 *  
 *  Author:     Norman J. Nolasco [ Advarion Incorporated ]
 *
 *  Created:    Tuesday, May 14, 2019 - 04:49:33 AM (CST)
 *
 *  Notes:
 *
 *
 *  Revisions:
 *      05/14/2019  NJN     File Created - Python Generator
 *      
 *      
 *  Copyright (c) 2019 - Advarion Incorporated - All Rights Reserved.
 *  Unauthorized copying of this file via any medium is strictly prohibited.
 *  Proprietary and Confidential.
 *
 *******************************************************************************
 */

export const LOCATIONZIPCODE_LIST_CONTAINER_LOADED = 'LOCATIONZIPCODE_LIST_CONTAINER_LOADED';
export const LOCATIONZIPCODE_LIST_CONTAINER_UNLOADED = 'LOCATIONZIPCODE_LIST_CONTAINER_UNLOADED';
export const LOCATIONZIPCODE_LIST_TABLE_LOADED = 'LOCATIONZIPCODE_LIST_TABLE_LOADED';
export const LOCATIONZIPCODE_LIST_TABLE_UNLOADED = 'LOCATIONZIPCODE_LIST_TABLE_UNLOADED';

export const LOCATIONZIPCODE_LIST_CHANGE_GROUP = 'LOCATIONZIPCODE_LIST_CHANGE_GROUP';
export const LOCATIONZIPCODE_SELECT_ROW = 'LOCATIONZIPCODE_SELECT_ROW';

export const LOCATIONZIPCODE_ADD = 'LOCATIONZIPCODE_ADD';
export const LOCATIONZIPCODE_EDIT = 'LOCATIONZIPCODE_EDIT';
export const LOCATIONZIPCODE_DELETE = 'LOCATIONZIPCODE_DELETE';
export const LOCATIONZIPCODE_OPEN_WARNING = 'LOCATIONZIPCODE_OPEN_WARNING';
export const LOCATIONZIPCODE_CLOSE_WARNING = 'LOCATIONZIPCODE_CLOSE_WARNING';
export const LOCATIONZIPCODE_DELETE_DISABLE = 'LOCATIONZIPCODE_DELETE_DISABLE';
export const LOCATIONZIPCODE_VIEW_CHILD_ITEMS = 'LOCATIONZIPCODE_VIEW_CHILD_ITEMS';

export const LOCATIONZIPCODE_EDIT_CONTAINER_LOADED = 'LOCATIONZIPCODE_EDIT_CONTAINER_LOADED';
export const LOCATIONZIPCODE_EDIT_CONTAINER_UNLOADED = 'LOCATIONZIPCODE_EDIT_CONTAINER_UNLOADED';
export const LOCATIONZIPCODE_EDIT_FORM_LOADED = 'LOCATIONZIPCODE_EDIT_FORM_LOADED';
export const LOCATIONZIPCODE_EDIT_FORM_UNLOADED = 'LOCATIONZIPCODE_EDIT_FORM_UNLOADED';

export const LOCATIONZIPCODE_SET_GROUP_SELECT = 'LOCATIONZIPCODE_SET_GROUP_SELECT';
export const LOCATIONZIPCODE_EDIT_DATA_LOAD = 'LOCATIONZIPCODE_EDIT_DATA_LOAD';

export const LOCATIONZIPCODE_EDIT_CONTAINER_SUBMIT = 'LOCATIONZIPCODE_EDIT_CONTAINER_SUBMIT';
export const LOCATIONZIPCODE_EDIT_CONTAINER_CANCEL = 'LOCATIONZIPCODE_EDIT_CONTAINER_CANCEL';


// WEBPACK FOOTER //
// ./src/constants/actionTypeLocationZipCodes.js